
import React, { useEffect } from 'react';

const XMLSitemap: React.FC = () => {
  useEffect(() => {
    // Add sitemap links to document head for SEO
    const sitemapLink = document.createElement('link');
    sitemapLink.rel = 'sitemap';
    sitemapLink.type = 'application/xml';
    sitemapLink.href = '/sitemap.xml';
    
    // Check if sitemap link already exists
    const existingSitemap = document.querySelector('link[rel="sitemap"]');
    if (!existingSitemap) {
      document.head.appendChild(sitemapLink);
    }

    return () => {
      // Cleanup on unmount
      if (sitemapLink.parentNode) {
        sitemapLink.parentNode.removeChild(sitemapLink);
      }
    };
  }, []);

  return null;
};

export default XMLSitemap;
